import { useMemo } from 'react';
import { Tab } from '@mui/material';
import { useAuth } from 'contexts/authContext';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { navbarRoutesList } from 'root/pathnames';
import { User } from 'types/user';
import { useRoutesMatch } from 'utils/hooks';
import { getIcon } from 'utils/icons.utils';
import { createBadgeTab } from './createBadgeTab';
import { TabsStyled } from './Navbar.styles';
import { getClientNavItems } from './navOptions';

interface Props {
  user: User;
}

export const NavTabsClient = ({ user }: Props) => {
  const { i18n } = useTranslation('menu');
  const { logoutUser } = useAuth();

  const navItems = useMemo(() => getClientNavItems(i18n), [i18n]);

  const navItemsList = useMemo(
    () => [
      navItems.inquiries,
      navItems.offers,
      navItems.orders,
      navItems.jobs,
      navItems.invoices,
      navItems.reports,
    ],
    [navItems],
  );

  const routeMatch = useRoutesMatch(navbarRoutesList);
  const matchedPath = routeMatch?.pattern.path;

  return (
    <TabsStyled value={matchedPath} variant='scrollable' scrollButtons='auto'>
      <Tab
        className='HomeTab'
        id={navItems.home.name}
        label={navItems.home.title}
        component={Link}
        to={navItems.home.url}
        value={navItems.home.value}
      />
      {navItemsList.map(({ name, title, url, value, icon }) => (
        <Tab
          key={name}
          id={name}
          label={title}
          component={Link}
          to={url}
          value={value}
          icon={getIcon(icon)}
          iconPosition='start'
        />
      ))}
      <Tab
        id={navItems.newsletter.name}
        label={navItems.newsletter.title}
        component='a'
        target='_blank'
        href={navItems.newsletter.url}
        value={navItems.newsletter.value}
        icon={getIcon(navItems.newsletter.icon)}
        iconPosition='start'
      />
      <Tab disabled sx={{ maxWidth: 'none', flex: '1 1 0' }} value='spacer' />
      <Tab
        id={navItems.account.name}
        label={user.code}
        component={Link}
        to={navItems.account.url}
        value={navItems.account.value}
        icon={getIcon(navItems.account.icon)}
        iconPosition='start'
      />
      <Tab
        id={navItems.alerts.name}
        component={createBadgeTab(
          navItems.alerts.url,
          navItems.alerts.alertsContextKey,
        )}
        value={navItems.alerts.value}
        icon={getIcon(navItems.alerts.icon)}
        iconPosition='start'
      />
      <Tab
        id={navItems.logout.name}
        onClick={() => logoutUser('logout')}
        value={navItems.logout.value}
        icon={getIcon(navItems.logout.icon, {
          fontSize: 'medium',
          sx: { opacity: 1 },
        })}
        iconPosition='start'
      />
    </TabsStyled>
  );
};
